import React, { useState, useEffect } from 'react'
import {
  Button,
  Input,
  Divider,
  Row,
  Col,
  message,
  Form,
  Spin,
  InputNumber,
  Table,
  Modal
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useDispatch, useStore, useSelector } from 'react-redux'
import {
  loadIsRegistorLoading,
  loadRegOutletsLoading,
  loadOutletRegisters,
  loadIsRegistorOpen,
  loadClosedRegData
} from '../../../appRedux/actions/Sell'
import {
  loadIsSelectReg,
  loadOpenClosePaySummary
} from '../../../appRedux/actions/CommonData'
import OpeningFloat from '../CashManagement/OpeningFloat'
import RegClosedListing from './RegClosedListing'
import InfoToPrint from '../../../components/InfoToPrint'
import { OPEN_CLOSE } from '../../../constants/Pages'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import {
  checkRightspermissions,
  customParse,
  formatDigits,
  isEmptyObject,
  notAllowMsgCheck,
  removeSpacewithLowerCaseString
} from '../../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import ExpandView from './ExpandView'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const confirm = Modal.confirm
const Listing = props => {
  const modalRole = props.role
  const history = useHistory()
  const store = useStore()
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getReduxIsRegisterLoading = useSelector(
    ({ Sell }) => Sell.cashManageIsRegistorLoading
  )

  const getReduxIsRegisterOpen = useSelector(
    ({ Sell }) => Sell.cashManageIsRegistorOpen
  )

  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )

  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )

  const getReduxOpenListingDataLoad = useSelector(
    ({ Sell }) => Sell.openCloseListingDataLoad
  ) //to update Data in Open/Close -> Open Listing

  const getReduxClosedRegData = useSelector(
    ({ Sell }) => Sell.opencloseRegClosedData
  )
  const getReduxDataSource = useSelector(
    ({ commonConfigs }) => commonConfigs.getPaySummary
  )
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [getIsSpinning, setIsSpinning] = useState(false)
  const [getCashTableData, setCashTableData] = useState([])
  const [isLoadingTable, setIsLoadingTable] = React.useState(true)
  const [getSelectedOutlet, setSelectedOutlet] = React.useState({})
  const [getSelectedReg, setSelectedReg] = React.useState({})
  const [getCountedValue, setCountedValue] = React.useState('0.00')
  const [getExpectedTotal, setExpectedTotal] = React.useState('0.00')
  const [getDifferenceValue, setDifferenceValue] = React.useState('0.00')
  // const [getIsMinus, setIsMinus] = React.useState(false);
  const [getTotalColor, setTotalColor] = React.useState('rgb(215, 113, 115)')
  const [getPagination, setPagination] = React.useState({
    CashManagementID: '',
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true
  })
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [getOutletName, setOutletName] = useState('')
  const [getRegName, setRegName] = useState('')

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!checkIsWeb().exist) {
        postDataToApp(
          PostAppTypes.PAGE_HEADER,
          getReduxIsRegisterOpen
            ? 'sell.openclose.closereg'
            : 'sell.openclose.openreg'
        )
      }

      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    if (getReduxDataSource && getReduxDataSource.length > 0) {
      let expectedTotal = customParse('0.00')
      // getReduxDataSource.map((e) => {
      //   if (e.isPrimary) {
      //     expectedTotal =
      //       getReduxClosedRegData &&
      //         getReduxClosedRegData.outletRegister &&
      //         getReduxClosedRegData.outletRegister.expected
      //         ? customParse(
      //           getReduxClosedRegData.outletRegister.expected + e.expected
      //         ).toFixed(getDecimalPlaces)
      //         : customParse("0.00").toFixed(getDecimalPlaces);
      //   } else {
      //     if (e.paymentTypes != "LOYALTY") {
      //       expectedTotal = customParse(expectedTotal + e.expected).toFixed(getDecimalPlaces);
      //     }
      //   }
      // });
      getReduxDataSource.map(e => {
        if (e.paymentTypes !== 'Totals') {
          expectedTotal += e.expected
        }
      })
      setExpectedTotal(
        expectedTotal ? formatDigits(expectedTotal, getDecimalPlaces) : '0.00'
      )
    }
  }, [getReduxDataSource, getReduxClosedRegData])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let outlet = false
      let reg = false
      if (getReduxSelectedStoreOutlets.id) {
        // setSelectedOutlet(getReduxSelectedStoreOutlets.id);
        setOutletName(
          getReduxSelectedStoreOutlets && getReduxSelectedStoreOutlets.outlet
            ? getReduxSelectedStoreOutlets.outlet
            : ''
        )
        outlet = getReduxSelectedStoreOutlets.id
      } else {
        let selectedLocalOut = localStorage.getItem('selectedOut')
        if (selectedLocalOut) {
          selectedLocalOut = JSON.parse(selectedLocalOut)
          // setSelectedOutlet(
          //   getReduxSelectedStoreOutlets.id
          //     ? getReduxSelectedStoreOutlets.id
          //     : selectedLocalOut.id
          // );
          setOutletName(
            selectedLocalOut && selectedLocalOut.outlet
              ? selectedLocalOut.outlet
              : ''
          )
          outlet = getReduxSelectedStoreOutlets.id
            ? getReduxSelectedStoreOutlets.id
            : selectedLocalOut.id
        } else {
          setOutletName('')
        }
      }

      if (getReduxSelectedOutletReg.id) {
        setRegName(
          getReduxSelectedOutletReg && getReduxSelectedOutletReg.register
            ? getReduxSelectedOutletReg.register
            : ''
        )
        reg =
          getReduxSelectedOutletReg && getReduxSelectedOutletReg.id
            ? getReduxSelectedOutletReg.id
            : ''
      } else {
        let selectedReg = localStorage.getItem('selectedReg')
        if (selectedReg) {
          selectedReg = JSON.parse(selectedReg)
          setRegName(
            getReduxSelectedOutletReg.register
              ? getReduxSelectedOutletReg.register
              : selectedReg.register
          )
          reg = getReduxSelectedOutletReg.id
            ? getReduxSelectedOutletReg.id
            : selectedReg.id
        } else {
          setRegName('')
        }
      }

      if (!outlet || !reg) {
        dispatch(loadIsSelectReg(true))
      }

      return () => (mounted = false)
      // //;
    }
  }, [getReduxSelectedStoreOutlets, getReduxSelectedOutletReg])

  React.useEffect(() => {
    let cashmanageId = localStorage.getItem('cashManageID')
    let regID = ''
    let outletID = ''
    if (cashmanageId) {
      let dataBody = {
        CashManagementID: cashmanageId
      }
      dispatch(loadClosedRegData(dataBody, false))
    }

    //default selected outlet & register info
    let selectedLocalOut = localStorage.getItem('selectedOut')
    let selectedLocalReg = localStorage.getItem('selectedReg')
    if (selectedLocalOut) {
      selectedLocalOut = JSON.parse(selectedLocalOut)
      if (selectedLocalOut.id) {
        outletID = selectedLocalOut.id
        let body = {
          OutletID: selectedLocalOut.id
        }
        dispatch(loadRegOutletsLoading(true))
        dispatch(loadOutletRegisters(body, isOnline))
      }
      setSelectedOutlet(selectedLocalOut)
    }
    if (selectedLocalReg) {
      selectedLocalReg = JSON.parse(selectedLocalReg)
      setSelectedReg(selectedLocalReg)
    }

    //getting pay summary info
    if (cashmanageId && outletID) {
      let body = {
        CMID: cashmanageId,
        OutID: outletID,
        IsClosed: false
      }
      dispatch(loadOpenClosePaySummary(body))
    }
  }, [getReduxOpenListingDataLoad]) //load here

  React.useEffect(() => {
    dispatch(setCommonConfigs(OPEN_CLOSE))
  }, [])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function onCountedChange (e, record) {
    let closeAmount = e
    let countedTotal = customParse('0.00')
    let differenceTotal = customParse('0.00')
    // let closeAmount = form.getFieldValue(`closeAmount-${record.id}`);
    // if (closeAmount) {

    // }
    closeAmount = closeAmount ? customParse(closeAmount) : 0
    let expected = record.expected
      ? customParse(record.expected)
      : customParse('0.00')
    if (record.isPrimary) {
      // expected =
      //   getReduxClosedRegData &&
      //     getReduxClosedRegData.outletRegister &&
      //     getReduxClosedRegData.outletRegister.expected
      //     ? customParse(
      //       getReduxClosedRegData.outletRegister.expected + expected
      //     )
      //     : customParse("0.00");
    }
    let difference = formatDigits(closeAmount - expected, getDecimalPlaces)
    // let isMinus = difference < 0 ? true : false;
    // setIsMinus(isMinus);
    form.setFieldsValue({ [`difference${record.id}`]: difference })

    //for counted total
    getReduxDataSource &&
      getReduxDataSource.length > 0 &&
      getReduxDataSource.map(e => {
        let IsShow =
          e.expected > 0 &&
          e.paymentTypes != 'LOYALTY' &&
          e.paymentTypes != 'STORE CREDIT' &&
          e.paymentTypes != 'Totals'
            ? true
            : e.isPrimary
            ? true
            : false
        if (IsShow) {
          let amount = form.getFieldValue(`closeAmount${e.id}`)
          countedTotal = amount
            ? customParse(countedTotal + amount)
            : countedTotal
        }
        if (e.paymentTypes == 'LOYALTY') {
          let amount = e.counted && e.counted > 0 ? e.counted : 0
          countedTotal = amount
            ? customParse(countedTotal + amount)
            : countedTotal
        }
        if (e.paymentTypes == 'STORE CREDIT') {
          let amount = e.counted && e.counted > 0 ? e.counted : 0
          countedTotal = amount
            ? customParse(countedTotal + amount)
            : countedTotal
        }
      })
    setCountedValue(
      countedTotal
        ? formatDigits(countedTotal, getDecimalPlaces)
        : customParse('0.00').toFixed(getDecimalPlaces)
    )
    setTotalColor(
      countedTotal && countedTotal < getExpectedTotal
        ? 'rgb(215, 113, 115)'
        : '#41af4b'
    )

    //for difference total
    getReduxDataSource &&
      getReduxDataSource.length > 0 &&
      getReduxDataSource.map(e => {
        let IsShow =
          e.expected > 0 &&
          e.paymentTypes != 'LOYALTY' &&
          e.paymentTypes != 'STORE CREDIT' &&
          e.paymentTypes != 'Totals'
            ? true
            : e.isPrimary
            ? true
            : false
        if (IsShow) {
          let amountDiff = form.getFieldValue(`difference${e.id}`)
            ? customParse(form.getFieldValue(`difference${e.id}`))
            : 0
          differenceTotal = amountDiff
            ? customParse(differenceTotal + amountDiff)
            : differenceTotal
        }
      })

    const diff = differenceTotal
      ? formatDigits(differenceTotal, getDecimalPlaces)
      : '0.00'
    setDifferenceValue(diff)
  }

  const columns = [
    {
      title: <IntlMessages id='sell.openclose.col1' />,
      width: 300,
      dataIndex: 'paymentTypes',
      key: 'paymentTypes',
      render: (text, record) => {
        return (
          <div>
            <strong>
              {text}
              {/* <IntlMessages id="sell.openclose.cash" /> */}
            </strong>
            {record.isPrimary && (
              <p className='gx-link payment-summary-wd'>
                <IntlMessages id='sell.openclose.col1desc' />
              </p>
            )}
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='sell.openclose.col2' />,
      dataIndex: 'expected',
      key: 'expected',
      render: (text, record) => {
        text = text ? formatDigits(text, getDecimalPlaces) : customParse('0.00')
        let expected = customParse('0.00').toFixed(getDecimalPlaces)
        if (record.isPrimary) {
          expected =
            getReduxClosedRegData &&
            getReduxClosedRegData.outletRegister &&
            getReduxClosedRegData.outletRegister.expected
              ? formatDigits(
                  getReduxClosedRegData.outletRegister.expected + text,
                  getDecimalPlaces
                )
              : '0.00'
        }
        return (
          <div>
            {record.isPrimary ? (
              <>
                <strong>
                  {text}
                  {/* {expected} */}
                  {getCurrSymbol}
                </strong>
              </>
            ) : record.paymentTypes == 'Total' ? (
              <div>
                <h3>
                  <strong>
                    {getExpectedTotal}
                    {getCurrSymbol}
                  </strong>
                </h3>
              </div>
            ) : (
              <>
                <strong>
                  {text ? text : '0.00'}
                  {getCurrSymbol}
                </strong>
              </>
            )}
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='sell.openclose.col3' />,
      dataIndex: 'counted',
      width: 200,
      key: 'counted',
      render: (text, record) => {
        let closingAmount = customParse('0.00')
        let IsShow =
          record.expected > 0 &&
          record.paymentTypes != 'LOYALTY' &&
          record.paymentTypes != 'STORE CREDIT' &&
          record.paymentTypes != 'Totals'
            ? true
            : record.isPrimary
            ? true
            : false
        //   let IsStoreCredit = removeSpacewithLowerCaseString(record.paymentTypes) == "storecredit" ? true : false;
        //  let storeCreditAmount = IsStoreCredit ?   record.expected : customParse("0.00");

        getReduxDataSource &&
          getReduxDataSource.length > 0 &&
          getReduxDataSource.map(e => {
            if (IsShow) {
              let amount = form.getFieldValue(`closeAmount${e.id}`)
                ? customParse(form.getFieldValue(`closeAmount${e.id}`))
                : customParse('0.00')
              closingAmount = formatDigits(
                closingAmount + amount,
                getDecimalPlaces
              )
            }
          })
        return (
          <div>
            {record.paymentTypes != 'Totals' && IsShow && (
              <Form
                form={form}
                name='closeRegister'
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                scrollToFirstError
              >
                <Form.Item
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: (
                  //       <IntlMessages id="setup.salestax.pleaseamount" />
                  //     ),
                  //   },
                  // ]}
                  name={`closeAmount${record.id}`}
                >
                  <InputNumber
                  type="number"
                    className='w-100'
                    placeholder='Enter Amount'
                    min={0}
                    max={100000000}
                    step={0.1}
                    onChange={e => onCountedChange(e, record)}
                    // disabled = {IsStoreCredit}
                    // value = {IsStoreCredit ? storeCreditAmount :  closingAmount }
                  />
                </Form.Item>
              </Form>
            )}

            {(record.paymentTypes == 'LOYALTY' ||
              record.paymentTypes == 'STORE CREDIT') &&
              record.counted &&
              record.counted > 0 && (
                <div>
                  <h3>
                    <strong>
                      {record.counted}
                      {getCurrSymbol}
                    </strong>
                  </h3>
                </div>
              )}

            {record.paymentTypes == 'Totals' && (
              <div>
                <h3 style={{ color: getTotalColor }}>
                  <strong>
                    {getCountedValue}
                    {getCurrSymbol}
                  </strong>
                </h3>
              </div>
            )}
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='sell.openclose.col4' />,
      key: 'differences',
      dataIndex: 'differences',
      render: (text, record) => {
        return (
          <div>
            {record.paymentTypes != 'Totals' ? (
              <Form
                form={form}
                name='closeRegister'
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                scrollToFirstError
              >
                <Form.Item name={`difference${record.id}`}>
                  <InputNumber
                  type="number"
                    style={{
                      color:
                        form.getFieldValue(`difference${record.id}`) &&
                        form.getFieldValue(`difference${record.id}`) < 0
                          ? 'rgb(215, 113, 115)'
                          : '#41af4b',
                      backgroundColor: 'white'
                    }}
                    className='w-100'
                    disabled
                    bordered={false}
                  />
                </Form.Item>
              </Form>
            ) : (
              <div>
                <h3
                  style={{
                    color:
                      getDifferenceValue && customParse(getDifferenceValue) < 0
                        ? 'rgb(215, 113, 115)'
                        : '#41af4b'
                  }}
                >
                  <strong>
                    {`${
                      getDifferenceValue ? getDifferenceValue : '0.00'
                    } ${getCurrSymbol}`}
                  </strong>
                </h3>
              </div>
            )}
          </div>
        )
      }
    }
  ]

  const onFinishFailed = errorInfo => {
    message.error('Please provide info...')
  }

  async function postCashService (body, behaviour) {
    // ;
    const cashInOutService = ds.postCashManagementService(body, behaviour)
    await cashInOutService
      .then(res => {
        if (res && res.msg && res.msg == 'Register Closed') {
          form.resetFields()
          localStorage.setItem('cashManageID', '')
          localStorage.setItem('closedCashManageID', body.CashManageID)
          dispatch(loadIsRegistorOpen(false))
          dispatch(loadIsRegistorLoading(false))
          dispatch(loadClosedRegData({}, true))
          if (getSelectedOutlet && getSelectedOutlet.id) {
            let bodyDouble = {
              CMID: body.CashManageID,
              OutID: getSelectedOutlet.id,
              IsClosed: true
            }
            dispatch(loadOpenClosePaySummary(bodyDouble))
          }
          message.success('Register Closed Successfully...')
        } else {
          message.error('Closing Register Failed...')
          dispatch(loadIsRegistorLoading(false))
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        dispatch(loadIsRegistorLoading(false))
        // setIsSpinning(false);
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      })
  }

  const onFinish = values => {
    confirm({
      title: 'Are you sure Counted amounts are right?',
      content: `Please make sure your provided amounts in Counted column are right`,
      okText: "Yes, I'm Sure",
      cancelText: 'No, checking again',
      okButtonProps:{className: 'dk-btn-add close-reg-btn'},
      cancelButtonProps: {className: "dk-btn-cancel close-reg-btn"},
      onOk () {
        finishProceed(values)
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }

  function finishProceed (values) {
    let closingAmount = 0
    let payTypeAmounts = []
    let payType = {
      PaymentTypeID: '',
      Amount: 0
    }
    getReduxDataSource &&
      getReduxDataSource.length > 0 &&
      getReduxDataSource.map(e => {
        let IsShow =
          e.expected > 0 &&
          e.paymentTypes != 'LOYALTY' &&
          e.paymentTypes != 'STORE CREDIT' &&
          e.paymentTypes != 'Totals'
            ? true
            : e.isPrimary
            ? true
            : false
        closingAmount = e.isPrimary
          ? form.getFieldValue(`closeAmount${e.id}`)
          : closingAmount
        if (IsShow) {
          const primaryDiffAmount = form.getFieldValue(`difference${e.id}`)
          const amount = form.getFieldValue(`closeAmount${e.id}`)
          // closingAmount = closingAmount + amount;
          // closingAmount = amount;
          payType.Amount = amount ? amount : 0 // id most important from backend! --> first always will be primary
          payType.PaymentTypeID = e.payID
          payType.Difference = e.isPrimary
            ? customParse(primaryDiffAmount ? primaryDiffAmount : 0)
            : 0
          payTypeAmounts.push({ ...payType })
        }
      })

    // for (let i = 0; i < getReduxDataSource.length; i++) {}
    if (values) {
      let localRegID =
        localStorage.getItem('selectedReg') != ''
          ? JSON.parse(localStorage.getItem('selectedReg'))
          : false
      let regID =
        getReduxSelectedOutletReg && getReduxSelectedOutletReg.id
          ? getReduxSelectedOutletReg.id
          : localRegID && localRegID.id
          ? localRegID.id
          : false
      let cashmanageId = localStorage.getItem('cashManageID')

      if (regID && cashmanageId) {
        dispatch(loadIsRegistorLoading(true))
        let body = {
          RegisterID: regID,
          CashManageID: cashmanageId,
          Amount: closingAmount,
          Note: values.note ? values.note : '',
          IsOpening: false,
          PayTypeAmount: payTypeAmounts
        }
        postCashService(body, BEHAVIOUR_TYPE.UPDATE)
      }
    } else {
      message.error('Please provide proper information')
    }
  }

  return getIsAllowRead ? (
    <div className='Content-wrapper CloseRegister-pg'>
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={getReduxIsRegisterLoading}
        size='large'
      >
        {getOutletName && getRegName ? (
          <>
            {checkIsWeb().exist && (
              <Row className='align-items-center justify-content-center mb-3 RegisterClosureSummary-header'>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <h1 className='mb-0'>
                    {getReduxIsRegisterOpen ? (
                      <IntlMessages id='sell.openclose.closereg' />
                    ) : (
                      <IntlMessages id='sell.openclose.openreg' />
                    )}
                  </h1>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}>
                    <InfoToPrint
                      role='OpenClose'
                      isCurrentOpened={getReduxIsRegisterOpen}
                      showExtraPrinters={
                        !checkIsWeb().exist
                          ? localStorage.getItem('extraPrints') &&
                            localStorage.getItem('extraPrints') == '1'
                            ? true
                            : false
                          : false
                      }
                    />
                </Col>
              </Row>
            )}

            <Row className='dk-row-bg-color m-0 Sec-heading-bg'>
            <Col lg={18} md={18} sm={14} xs={24}>
                <p className='title vd-hero-intro custom-font-color-black m-0'>
                  {getReduxIsRegisterOpen ? (
                    <IntlMessages id='sell.openclose.closereg2' />
                  ) : (
                    <IntlMessages id='sell.openclose.openreg2' />
                  )}
                </p>
              </Col>
              {!checkIsWeb().exist && (
               <Col lg={6} md={6} sm={10} xs={24}>
                  <div style={{ float: 'right' }}>
                    <InfoToPrint
                      role='OpenClose'
                      isCurrentOpened={getReduxIsRegisterOpen}
                      showExtraPrinters={true}
                    />
                  </div>
                </Col>
              )}

            </Row>
            
            <div className='CloseRegister-pg-div'>

              <Row className='mt-4 mb-4'
              >
                {!getReduxIsRegisterOpen ? (
                  <>
                    <div style={{ width: '100%' }}>
                      <OpeningFloat isCreateDisable={getIsDisableCreate} />
                    </div>
                  </>
                ) : (
                  <>
                    <Col lg={6} md={24} sm={24} xs={24}>
                      <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                        <IntlMessages id='sell.openclose.regdetail' />
                      </h2>
                    </Col>

                    <Col lg={18} md={24} sm={24} xs={24}>
                      <Row>
                        <Col lg={4} md={4} sm={8} xs={24}>
                          <strong>
                            <IntlMessages id='sell.openclose.regdetail1' />
                          </strong>
                        </Col>
                        <Col lg={20} md={20} sm={16} xs={24}>
                          {getReduxSelectedStoreOutlets &&
                          getReduxSelectedStoreOutlets.outlet
                            ? getReduxSelectedStoreOutlets.outlet
                            : getSelectedOutlet && getSelectedOutlet.outlet
                            ? getSelectedOutlet.outlet
                            : '---'}
                        </Col>
                      </Row>

                      <Row className='mt-3'>
                      <Col lg={4} md={4} sm={8} xs={24}>
                          <strong>
                            <IntlMessages id='sell.openclose.regdetail2' />
                          </strong>
                        </Col>
                        <Col lg={20} md={20} sm={16} xs={24}>
                          {getReduxSelectedOutletReg &&
                          getReduxSelectedOutletReg.register
                            ? getReduxSelectedOutletReg.register
                            : getSelectedReg && getSelectedReg.register
                            ? getSelectedReg.register
                            : '---'}
                        </Col>
                      </Row>

                      <Row className='mt-3'>
                      <Col lg={4} md={4} sm={8} xs={24}>
                          <strong>
                            <IntlMessages id='sell.openclose.regdetail3' />
                          </strong>
                        </Col>
                        <Col lg={20} md={20} sm={16} xs={24}>
                          {getReduxClosedRegData &&
                          getReduxClosedRegData.outletRegister &&
                          getReduxClosedRegData.outletRegister.closure
                            ? getReduxClosedRegData.outletRegister.closure
                            : '1'}
                        </Col>
                      </Row>

                      <Row className='mt-3'>
                      <Col lg={4} md={4} sm={8} xs={24}>
                          <strong>
                            <IntlMessages id='sell.openclose.regdetail4' />
                          </strong>
                        </Col>
                        <Col lg={20} md={20} sm={16} xs={24}>
                          {getReduxClosedRegData &&
                          getReduxClosedRegData.outletRegister &&
                          getReduxClosedRegData.outletRegister.openedOnDate
                            ? getReduxClosedRegData.outletRegister.openedOnDate
                            : getSelectedReg && getSelectedReg.openedOnDate
                            ? getSelectedReg.openedOnDate
                            : '---'}
                        </Col>
                      </Row>
                    </Col>
                  </>
                )}
              </Row>

              <Divider className='custom-mgt-mgb-20' />

              {getReduxIsRegisterOpen ? (
                <>
                  <Row className='mt-4 mb-4'>
                  <Col lg={6} md={24} sm={24} xs={24}>
                      <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                        <IntlMessages id='sell.openclose.paymentsumry' />{' '}
                      </h2>
                      <p className='dk-font-size-15'>
                        <IntlMessages id='sell.openclose.paymentsumry2' />
                      </p>
                    </Col>

                    <Col lg={18} md={24} sm={24} xs={24}>
                     
                      <Spin
                        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
                        spinning={
                          getReduxClosedRegData &&
                          getReduxClosedRegData.outletRegister
                            ? false
                            : true
                        }
                        size='large'
                      >
                        <Table
                          className='gx-table-responsive expanded-table-parent MinWidth-auto'
                          columns={columns}
                          dataSource={getReduxDataSource}
                          loading={
                            getReduxDataSource && getReduxDataSource.length > 0
                              ? false
                              : true
                          }
                          expandable={{
                            expandedRowRender: record => (
                              <ExpandView
                                recPay={record.receivedPay}
                                getCurrSymbol={getCurrSymbol}
                              />
                            ),
                            rowExpandable: record => record.isPrimary
                          }}
                          pagination={false}
                          footer={false}
                        />
                      </Spin>
                    </Col>
                  </Row>

                  <Divider className='custom-mgt-mgb-20' />

                  <Row className='mt-4 mb-4'>
                  <Col lg={6} md={24} sm={24} xs={24}>
                      <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                        <IntlMessages id='sell.openclose.closingsumry' />
                      </h2>
                    </Col>

                    <Col lg={18} md={24} sm={24} xs={24}>
                      <Form className='closeRegister-form'
                        form={form}
                        name='closeRegister'
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        initialValues={{
                          prefix: '86'
                        }}
                        layout='vertical'
                        scrollToFirstError
                      >
                        <Form.Item
                          className='ant-form-item-label-custom ant-form-margin-right'
                          name='note'
                          label={
                            <span>
                              <strong>
                                <IntlMessages id='sell.cashlisting.note' />
                              </strong>
                              {/* <Tooltip title="Brand Description"></Tooltip> */}
                            </span>
                          }
                        >
                          <Input.TextArea
                            placeholder='Type to add a Register Closure Note.'
                            rows={3}
                            // onChange={getCardPromoDesc}
                          />
                        </Form.Item>
                      </Form>
                    </Col>
                  </Row>

                  <Row>
                    

                    <Col lg={24} md={24} sm={24} xs={24} className='text-right'>
                      <Form
                        form={form}
                        name='closeRegister'
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        scrollToFirstError
                      >
                        <Button
                          htmlType='submit'
                          className='dk-btn-cancel'
                          type='primary'
                          size='large'
                          disabled={getIsDisableCreate}
                        >
                          <IntlMessages id='sell.openclose.closereg' />
                        </Button>
                      </Form>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  {localStorage.getItem('closedCashManageID') &&
                    localStorage.getItem('closedCashManageID') != '' && (
                      <RegClosedListing
                        cashManageID={localStorage.getItem(
                          'closedCashManageID'
                        )}
                      />
                    )}
                </>
              )}
            </div>
          </>
        ) : (
          <>
            <Row justify='center'>
              <Col>
                <h1>Kindly Select Register and Outlet</h1>
              </Col>
            </Row>
          </>
        )}
      </Spin>
    </div>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default Listing
